import React, {useContext, useRef, useState} from 'react';
import axios from 'axios';
import config from '../../../../config';
import UserContext from '../../UserContext';

// reactstrap
import {Col, Row} from 'reactstrap';

// components
import {toHtml} from '../../utilities';
import DialogLayout from "./DialogLayout";

// kendo react
import {Button} from '@progress/kendo-react-buttons';
import {Upload} from '@progress/kendo-react-upload';
import {Popover} from '@progress/kendo-react-tooltip';

// multilingual
import {
    hostIdFormattingKey, hostPendingSpecialKey, keysightGenerateLicensesV2Key,
    mainMessages, specialHandlingKey,
    specificHostFileKey, uploadFileKey
} from "../../../../assets/text/MultilingualText";
import {useLocalization} from "@progress/kendo-react-intl";
import {Label} from "@progress/kendo-react-labels";
import KSMPopover from "../../Popovers";
import {InfoIcon} from "../../icons";
import {saveHostToProfile} from "./utilities";


function PartialModal(props) {
    const {
        setIsLoading,
        hostDetails,
        assignedProducts,
        errors,
        setErrors,
        showError,
        createHost,
        resetSelectedProducts,
        closeModal,
        savedHostInfo,
        saveHostMethod = null,
        children,
    } = props;
    const {
        accessToken,
        siteLanguageDefault
    } = useContext(UserContext);
    const localization = useLocalization();

    const validate = () => {
        setErrors([]);
        if (saveHostMethod === null) {
            saveHostToProfile(
                accessToken,
                setIsLoading,
                showError,
                saveHostID,
                [],
                savedHostInfo,
                hostDetails,
                '',
                ''
            )
        } else {
            saveHostMethod(
                accessToken,
                setIsLoading,
                showError,
                saveHostID,
                [],
                savedHostInfo,
                hostDetails,
                '',
                ''
            )
        }

    }

    /*
     * saveHostID() saves the assigned host
    */
    const saveHostID = (savedData = null) => {
        let panelBarTitle = localization.toLanguageString(hostPendingSpecialKey, mainMessages[siteLanguageDefault][hostPendingSpecialKey]);
        let host = assignedProducts.find(host =>
            host.transaction_id &&
            host.is_partial === "Y"
        );
        let hostId = [null]


        createHost(panelBarTitle, host, hostId, "", "", savedData)
        resetSelectedProducts()
    }

    return (
        <DialogLayout
            closeModal={closeModal}
            productTable={children}
            errors={errors}
            validate={validate}
        >
            <Row>
                <div
                    className={'k-h4'}
                >
                    {localization.toLanguageString(specialHandlingKey, mainMessages[siteLanguageDefault][specialHandlingKey])}
                </div>
                <div
                    style={{
                        color: "black",
                        fontSize: "1rem"
                    }}
                >
                    {toHtml(localization.toLanguageString(keysightGenerateLicensesV2Key, mainMessages[siteLanguageDefault][keysightGenerateLicensesV2Key]))}
                </div>
            </Row>
        </DialogLayout>
    )
}

export default PartialModal;